// extracted by mini-css-extract-plugin
export default {"_":"menu____JL8Sc","block":"menu_block__D1tZZ","text":"menu_text__oFmSm"};